<template>
  <div class="learning-experiences-container">
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :matterId="egress_profile_matter_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix2="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
      :showMatterDescriptionView="true"
      :showLearningEvaluationView="true"
      :showLearningExperiencesView="true"
      :showPiaView="true"
      :showPdaView="true"
      :showPaView="true"
    ></NavigationBreadcrumb>
    <div class="mt-3">
      <h4 v-if="matter">
        {{
          $t("matterProgram.learningExperiencesView.learningExperiencesTitle", {
            code: egressProfilesMatter.effective_code,
            name: matter.name,
          }).toUpperCase()
        }}
      </h4>
    </div>
    <div class="d-flex">
      <GenericButtonDownload
        :tooltip_text="$t('matterProgram.learningExperiencesView.downloadXLS')"
        :click_button="DownloadXLS"
        :class="`ml-auto mr-3 mb-1`"
        :icon_excel="true"
      ></GenericButtonDownload>
      <!-- <b-button
        variant="primary"
        class="btn btn-primary ml-auto mr-3 noprint"
        @click="DownloadXLS"
        ><b-icon-download class="mr-1 icon-download"></b-icon-download>Descargar
        XLS</b-button
      > -->
    </div>
    <TableSkeleton
      v-if="loading"
      :columns="17"
      :rows="12"
      :table_props="{
        bordered: true,
        'no-border-collapse': true,
        small: true,
        responsive: true,
      }"
    />
    <b-table-simple
      v-else
      bordered
      no-border-collapse
      small
      responsive
      sticky-header="1000px"
      class="txt-custom"
    >
      <b-thead>
        <b-tr>
          <b-th class="text-center primary-header" colspan="3">
            {{
              $t(
                "matterProgram.learningExperiencesView.learningExperience"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="text-center primary-header" colspan="14">
            {{
              $t(
                "matterProgram.learningExperiencesView.summativeAndFormativeActivitiesAndEvaluations"
              )
            }}
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.numberAndNameEA"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("matterProgram.learningExperiencesView.learningOutcomes") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("matterProgram.learningExperiencesView.descriptionHeader") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.numberAndNameDirectedTeachingActivity"
              )
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.briefDescriptionForTeacher"
              )
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.briefDescriptionForStudent"
              )
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.connectionWithEnvironment"
              )
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("matterProgram.learningExperiencesView.achievementIndicators")
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("matterProgram.learningExperiencesView.directedTeachingHours")
            }}
            <br />
            <span class="font-weight-normal">{{
              $t("matterProgram.learningExperiencesView.pedagogicalHours")
            }}</span>
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("matterProgram.learningExperiencesView.autonomousWorkActivity")
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("matterProgram.learningExperiencesView.autonomousWorkHours")
            }}
            <br />
            <span class="font-weight-normal">{{
              $t("matterProgram.learningExperiencesView.chronologicalHours")
            }}</span>
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("matterProgram.learningExperiencesView.learningResources") }}
            <br />
            <span class="font-weight-normal">
              {{
                $t(
                  "matterProgram.learningExperiencesView.learningResourcesSubtitle"
                )
              }}<br />
              {{
                $t(
                  "matterProgram.learningExperiencesView.learningResourcesSubtitle2"
                )
              }}
            </span>
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("matterProgram.learningExperiencesView.educationalTechnology")
            }}
            <br />
            <span class="font-weight-normal">
              {{
                $t(
                  "matterProgram.learningExperiencesView.educationalTechnologySubtitle"
                )
              }}
            </span>
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.mandatoryBibliography"
              ).toUpperCase()
            }}
            <br />
            <span class="font-weight-normal">
              {{
                $t(
                  "matterProgram.learningExperiencesView.mandatoryBibliographySubtitle"
                )
              }}
            </span>
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.supplementaryBibliography"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.learningEnvironments"
              ).toUpperCase()
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t(
                "matterProgram.learningExperiencesView.numberOfStudents"
              ).toUpperCase()
            }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template
          v-if="
            learning_experiences &&
            (learning_experiences.learning_experiences.length > 0 ||
              learning_experiences.transversal_exams.length > 0)
          "
        >
          <template
            v-for="(
              learning_experience, index
            ) in learning_experiences.learning_experiences"
          >
            <template
              v-if="
                learning_experience.study_units.length > 0 ||
                learning_experience.epm_evaluations.length > 0
              "
            >
              <template v-if="learning_experience.study_units.length == 0">
                <b-tr
                  v-for="(
                    epm_evaluation, index2
                  ) in learning_experience.epm_evaluations"
                  :key="
                    'learning_experience' + index + 'epm-evaluation' + index2
                  "
                >
                  <b-td
                    v-if="index2 == 0"
                    :rowspan="learning_experience.epm_evaluations.length"
                    style="vertical-align: middle; text-align: justify"
                  >
                    <!-- N° y NOMBRE EA -->
                    {{
                      $t("matterProgram.learningExperiencesView.eaPrefix") +
                      " " +
                      learning_experience.order +
                      " - " +
                      learning_experience.name
                    }}</b-td
                  >
                  <b-td
                    v-if="index2 == 0"
                    :rowspan="learning_experience.epm_evaluations.length"
                  >
                    <!-- Resultado(s) de Aprendizaje -->
                  </b-td>
                  <b-td
                    v-if="index2 == 0"
                    :rowspan="learning_experience.epm_evaluations.length"
                    style="vertical-align: middle; text-align: justify"
                  >
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- DESCRIPCIÓN  -->
                      <template v-if="learning_experience.description">
                        <div
                          :id="`popover-learning_experience.description-${index}-${index2}`"
                        >
                          <RenderVHtml
                            :content="learning_experience.description"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-learning_experience.description-${index}-${index2}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="learning_experience.description"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <b-td>
                    <!-- N° y NOMBRE ACTIVIDAD DOCENCIA DIRIGIDA -->
                    <span v-if="epm_evaluation.type_name == 'Actividad'">{{
                      epm_evaluation.full_name
                    }}</span>
                    <template v-else>
                      <span>{{ epm_evaluation.full_name }}</span>
                    </template></b-td
                  >
                  <b-td>
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- Descripción breve DIRIGIDO AL DOCENTE -->
                      <template v-if="epm_evaluation.description">
                        <div
                          :id="`popover-epm_evaluation.description-${index}-${index2}`"
                        >
                          <RenderVHtml
                            :content="epm_evaluation.description"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-epm_evaluation.description-${index}-${index2}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="epm_evaluation.description"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <b-td>
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- Descripción breve DIRIGIDO AL ESTUDIANTE -->
                      <template v-if="epm_evaluation.description_for_student">
                        <div
                          :id="`popover-epm_evaluation.description_for_student-${index}-${index2}`"
                        >
                          <RenderVHtml
                            :content="epm_evaluation.description_for_student"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-epm_evaluation.description_for_student-${index}-${index2}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="epm_evaluation.description_for_student"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <!-- Vinculación con el Medio -->
                  <b-td>
                    <RenderVHtml
                      :class="{
                        'text-center':
                          epm_evaluation.connection_with_the_environment_description ==
                          '-',
                      }"
                      :content="
                        epm_evaluation.connection_with_the_environment_description
                      "
                    ></RenderVHtml>
                  </b-td>
                  <b-td
                    :class="[
                      epm_evaluation.evaluation_criterias_micro.length > 0
                        ? 'text-left'
                        : 'text-center',
                    ]"
                  >
                    <!-- Indicador(es) de logro -->
                    <template
                      v-if="
                        epm_evaluation.evaluation_criterias_micro.length > 0
                      "
                    >
                      <template
                        v-for="indicator in epm_evaluation.evaluation_criterias_micro"
                        class="indicator-content"
                      >
                        <b-badge
                          :key="indicator.id"
                          :id="`ec-badge-${indicator.id}`"
                          class="ec-micro-badge mr-1"
                          variant="info"
                          v-b-tooltip.v-secondary.noninteractive="
                            `${indicator.full_sentence}`
                          "
                        >
                          {{ indicator.study_unit__order }}.{{
                            indicator.order
                          }}
                        </b-badge>
                      </template>
                    </template>
                    <template v-else>
                      <div>{{ $t("reusable.common.notApplicable") }}</div>
                    </template>
                  </b-td>
                  <b-td>
                    <!-- Tiempo horas docencia dirigida -->
                    {{
                      epm_evaluation.suggested_hours
                        ? epm_evaluation.suggested_hours
                        : "-"
                    }}
                  </b-td>
                  <b-td class="text-justify">
                    <!-- Actividad de trabajo autónomo del/la estudiante -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_autonomous_activities
                          .length > 0
                      "
                    >
                      <RenderVHtml
                        v-for="learning_resource in epm_evaluation.epm_evaluation_autonomous_activities"
                        :key="learning_resource.id"
                        class="mr-1"
                        :content="learning_resource.name"
                      ></RenderVHtml>
                    </template>
                  </b-td>
                  <b-td>
                    <!-- Tiempo horas trabajo autónomo -->
                    {{
                      epm_evaluation.autonomous_work_hours
                        ? epm_evaluation.autonomous_work_hours
                        : "-"
                    }}
                  </b-td>
                  <b-td>
                    <!-- Recursos de aprendizaje -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_learning_resources
                          .length > 0
                      "
                    >
                      <div
                        v-for="learning_resource in epm_evaluation.epm_evaluation_learning_resources"
                        :key="learning_resource.id"
                      >
                        <RenderVHtml
                          :content="learning_resource.description"
                        ></RenderVHtml>
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- Tecnología educativa  -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_educational_technology
                          .length > 0
                      "
                    >
                      <div
                        v-for="epm_evaluation_educational_technology in epm_evaluation.epm_evaluation_educational_technology"
                        :key="epm_evaluation_educational_technology.id"
                      >
                        <RenderVHtml
                          :content="epm_evaluation_educational_technology.description"
                        ></RenderVHtml>
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td class="bibliography-table-cell">
                    <!-- BIBLIOGRAFÍA OBLIGATORIA -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_mandatory_bibliography
                          .length > 0
                      "
                    >
                      <template
                        v-for="epm_evaluation_mandatory in epm_evaluation.epm_evaluation_mandatory_bibliography"
                      >
                        <RenderVHtml
                          :key="'mandatory' + epm_evaluation_mandatory.id"
                          class="bibliography-content"
                          :content="
                            epm_evaluation_mandatory.bibliographic_resource__description
                          "
                        ></RenderVHtml>
                        <div
                          :key="
                            'mandatory-details' + epm_evaluation_mandatory.id
                          "
                          class="bibliography-details"
                        >
                          {{ epm_evaluation_mandatory.details }}
                        </div>
                        <BoundedRichText
                          class="bounded-biblio-content"
                          :key="
                            'bounded-biblio-mandatory' +
                            epm_evaluation_mandatory.id
                          "
                          :text="
                            epm_evaluation_mandatory.bibliographic_resource__description
                          "
                          :drop_text="epm_evaluation_mandatory.details"
                          :large="18"
                          :content_width="400"
                        ></BoundedRichText>
                      </template>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- BIBLIOGRAFÍA COMPLEMENTARIA -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_supplementary_bibliography
                          .length > 0
                      "
                    >
                      <template
                        v-for="epm_evaluation_supplementary in epm_evaluation.epm_evaluation_supplementary_bibliography"
                      >
                        <RenderVHtml
                          :key="
                            'supplementary' + epm_evaluation_supplementary.id
                          "
                          class="bibliography-content"
                          :content="
                            epm_evaluation_supplementary.bibliographic_resource__description
                          "
                        ></RenderVHtml>
                        <div
                          :key="
                            'supplementary-details' +
                            epm_evaluation_supplementary.id
                          "
                          class="bibliography-details"
                        >
                          {{ epm_evaluation_supplementary.details }}
                        </div>
                        <BoundedRichText
                          class="bounded-biblio-content"
                          :key="
                            'bounded-biblio-supplementary' +
                            epm_evaluation_supplementary.id
                          "
                          :text="
                            epm_evaluation_supplementary.bibliographic_resource__description
                          "
                          :drop_text="epm_evaluation_supplementary.details"
                          :large="18"
                          :content_width="400"
                        ></BoundedRichText>
                      </template>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td
                    :class="[
                      epm_evaluation.study_environments_students.length > 0
                        ? 'text-left'
                        : 'text-center',
                    ]"
                  >
                    <!-- AMBIENTES DE APRENDIZAJE -->
                    <template
                      v-if="
                        epm_evaluation.study_environments_students.length > 0
                      "
                    >
                      <div
                        v-for="environment in epm_evaluation.study_environments_students"
                        :key="environment.id"
                        variant="info"
                        class="mr-1"
                      >
                        - {{ environment.name }}:
                        {{ environment.suggested_students }}
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- Nº ESTUDIANTES -->
                    {{
                      epm_evaluation.suggested_students
                        ? epm_evaluation.suggested_students
                        : "-"
                    }}
                  </b-td>
                </b-tr>
              </template>
              <template v-else>
                <template
                  v-for="(
                    study_unit, index2
                  ) in learning_experience.study_units"
                >
                  <template v-if="study_unit.epm_evaluations.length > 0">
                    <b-tr
                      v-for="(
                        epm_evaluation, index3
                      ) in study_unit.epm_evaluations"
                      :key="
                        'learning_experience' +
                        index +
                        'study_unit' +
                        index2 +
                        'epm-evaluation' +
                        index3
                      "
                    >
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <!-- N° y NOMBRE EA -->
                        {{
                          $t("matterProgram.learningExperiencesView.eaPrefix") +
                          " " +
                          learning_experience.order +
                          " - " +
                          learning_experience.name
                        }}
                      </b-td>
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <!-- Resultado(s) de Aprendizaje -->
                        <div
                          v-for="(
                            item, index4
                          ) in learning_experience.study_units"
                          :key="
                            'learning_experience' +
                            index +
                            'study_unit' +
                            index2 +
                            'epm-evaluation' +
                            index3 +
                            '-' +
                            index4
                          "
                        >
                          {{
                            $t(
                              "matterProgram.learningExperiencesView.raPrefix"
                            ) +
                            item.order +
                            ". " +
                            item.full_sentence
                          }}
                        </div>
                      </b-td>
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <div
                          class="text-break"
                          @click="
                            (e) => e.target.classList.toggle('text-break')
                          "
                        >
                          <!-- DESCRIPCIÓN  -->
                          <template v-if="learning_experience.description">
                            <div
                              :id="`popover-learning_experience.description-${index}-${index2}-${index3}`"
                            >
                              <RenderVHtml
                                :content="learning_experience.description"
                              ></RenderVHtml>
                            </div>
                            <b-popover
                              :target="`popover-learning_experience.description-${index}-${index2}-${index3}`"
                              triggers="hover"
                              placement="right"
                            >
                              <RenderVHtml
                                class="popover-container"
                                :content="learning_experience.description"
                              ></RenderVHtml>
                            </b-popover>
                          </template>
                          <template v-else>
                            <div>{{ $t("reusable.common.notApplicable") }}</div>
                          </template>
                        </div>
                      </b-td>

                      <b-td>
                        <!-- N° y NOMBRE ACTIVIDAD DOCENCIA DIRIGIDA -->
                        <span v-if="epm_evaluation.type_name == 'Actividad'">{{
                          epm_evaluation.full_name
                        }}</span>
                        <template v-else>
                          <span>{{ epm_evaluation.full_name }}</span>
                        </template></b-td
                      >
                      <b-td>
                        <div
                          class="text-break"
                          @click="
                            (e) => e.target.classList.toggle('text-break')
                          "
                        >
                          <!-- Descripción breve DIRIGIDO AL DOCENTE -->
                          <template v-if="epm_evaluation.description">
                            <div
                              :id="`popover-epm_evaluation.description-${index}-${index2}-${index3}`"
                            >
                              <RenderVHtml
                                :content="epm_evaluation.description"
                              ></RenderVHtml>
                            </div>
                            <b-popover
                              :target="`popover-epm_evaluation.description-${index}-${index2}-${index3}`"
                              triggers="hover"
                              placement="right"
                            >
                              <RenderVHtml
                                class="popover-container"
                                :content="epm_evaluation.description"
                              ></RenderVHtml>
                            </b-popover>
                          </template>
                          <template v-else>
                            <div>{{ $t("reusable.common.notApplicable") }}</div>
                          </template>
                        </div>
                      </b-td>
                      <b-td>
                        <div
                          class="text-break"
                          @click="
                            (e) => e.target.classList.toggle('text-break')
                          "
                        >
                          <!-- Descripción breve DIRIGIDO AL ESTUDIANTE -->
                          <template
                            v-if="epm_evaluation.description_for_student"
                          >
                            <div
                              :id="`popover-epm_evaluation.description_for_student-${index}-${index2}-${index3}`"
                            >
                              <RenderVHtml
                                :content="
                                  epm_evaluation.description_for_student
                                "
                              ></RenderVHtml>
                            </div>
                            <b-popover
                              :target="`popover-epm_evaluation.description_for_student-${index}-${index2}-${index3}`"
                              triggers="hover"
                              placement="right"
                            >
                              <RenderVHtml
                                class="popover-container"
                                :content="
                                  epm_evaluation.description_for_student
                                "
                              ></RenderVHtml>
                            </b-popover>
                          </template>
                          <template v-else>
                            <div>{{ $t("reusable.common.notApplicable") }}</div>
                          </template>
                        </div>
                      </b-td>
                      <!-- Vinculación con el Medio -->
                      <b-td>
                        <RenderVHtml
                          :class="{
                            'text-center':
                              epm_evaluation.connection_with_the_environment_description ==
                              '-',
                          }"
                          :content="
                            epm_evaluation.connection_with_the_environment_description
                          "
                        ></RenderVHtml>
                      </b-td>
                      <b-td
                        :class="[
                          epm_evaluation.evaluation_criterias_micro.length > 0
                            ? 'text-left'
                            : 'text-center',
                        ]"
                      >
                        <!-- Indicador(es) de logro -->
                        <template
                          v-if="
                            epm_evaluation.evaluation_criterias_micro.length > 0
                          "
                        >
                          <template
                            v-for="indicator in epm_evaluation.evaluation_criterias_micro"
                            class="indicator-content"
                          >
                            <b-badge
                              :key="indicator.id"
                              :id="`ec-badge-${indicator.id}`"
                              class="ec-micro-badge mr-1"
                              variant="info"
                              v-b-tooltip.v-secondary.noninteractive="
                                `${indicator.full_sentence}`
                              "
                            >
                              {{ indicator.study_unit__order }}.{{
                                indicator.order
                              }}
                            </b-badge>
                          </template>
                        </template>
                        <template v-else>
                          <div>{{ $t("reusable.common.notApplicable") }}</div>
                        </template>
                      </b-td>
                      <b-td>
                        <!-- Tiempo horas docencia dirigida -->
                        {{
                          epm_evaluation.suggested_hours
                            ? epm_evaluation.suggested_hours
                            : "-"
                        }}
                      </b-td>
                      <b-td class="text-justify">
                        <!-- Actividad de trabajo autónomo del/la estudiante -->
                        <template
                          v-if="
                            epm_evaluation.epm_evaluation_autonomous_activities
                              .length > 0
                          "
                        >
                          <RenderVHtml
                            v-for="learning_resource in epm_evaluation.epm_evaluation_autonomous_activities"
                            :key="learning_resource.id"
                            class="mr-1"
                            :content="learning_resource.name"
                          ></RenderVHtml>
                        </template>
                      </b-td>
                      <b-td>
                        <!-- Tiempo horas trabajo autónomo -->
                        {{
                          epm_evaluation.autonomous_work_hours
                            ? epm_evaluation.autonomous_work_hours
                            : "-"
                        }}
                      </b-td>
                      <b-td>
                        <!-- Recursos de aprendizaje -->
                        <template
                          v-if="
                            epm_evaluation.epm_evaluation_learning_resources
                              .length > 0
                          "
                        >
                          <div
                            v-for="learning_resource in epm_evaluation.epm_evaluation_learning_resources"
                            :key="learning_resource.id"
                          >
                            <RenderVHtml
                              :content="learning_resource.description"
                            ></RenderVHtml>
                          </div>
                        </template>
                        <template v-else>{{
                          $t("reusable.common.notApplicable")
                        }}</template>
                      </b-td>
                      <b-td>
                        <!-- Tecnología educativa  -->
                        <template
                          v-if="
                            epm_evaluation.epm_evaluation_educational_technology
                              .length > 0
                          "
                        >
                          <div
                            v-for="epm_evaluation_educational_technology in epm_evaluation.epm_evaluation_educational_technology"
                            :key="epm_evaluation_educational_technology.id"
                          >
                            <RenderVHtml
                              :content="
                                epm_evaluation_educational_technology.description
                              "
                            ></RenderVHtml>
                          </div>
                        </template>
                        <template v-else>{{
                          $t("reusable.common.notApplicable")
                        }}</template>
                      </b-td>
                      <b-td class="bibliography-table-cell">
                        <!-- BIBLIOGRAFÍA OBLIGATORIA -->
                        <template
                          v-if="
                            epm_evaluation.epm_evaluation_mandatory_bibliography
                              .length > 0
                          "
                        >
                          <template
                            v-for="epm_evaluation_mandatory in epm_evaluation.epm_evaluation_mandatory_bibliography"
                          >
                            <RenderVHtml
                              :key="'mandatory' + epm_evaluation_mandatory.id"
                              class="bibliography-content"
                              :content="
                                epm_evaluation_mandatory.bibliographic_resource__description
                              "
                            ></RenderVHtml>
                            <div
                              :key="
                                'mandatory-details' +
                                epm_evaluation_mandatory.id
                              "
                              class="bibliography-details"
                            >
                              {{ epm_evaluation_mandatory.details }}
                            </div>
                            <BoundedRichText
                              class="bounded-biblio-content"
                              :key="
                                'bounded-biblio-mandatory' +
                                epm_evaluation_mandatory.id
                              "
                              :text="
                                epm_evaluation_mandatory.bibliographic_resource__description
                              "
                              :drop_text="epm_evaluation_mandatory.details"
                              :large="18"
                              :content_width="400"
                            ></BoundedRichText>
                          </template>
                        </template>
                        <template v-else>{{
                          $t("reusable.common.notApplicable")
                        }}</template>
                      </b-td>
                      <b-td>
                        <!-- BIBLIOGRAFÍA COMPLEMENTARIA -->
                        <template
                          v-if="
                            epm_evaluation
                              .epm_evaluation_supplementary_bibliography
                              .length > 0
                          "
                        >
                          <template
                            v-for="epm_evaluation_supplementary in epm_evaluation.epm_evaluation_supplementary_bibliography"
                          >
                            <RenderVHtml
                              :key="
                                'supplementary' +
                                epm_evaluation_supplementary.id
                              "
                              class="bibliography-content"
                              :content="
                                epm_evaluation_supplementary.bibliographic_resource__description
                              "
                            ></RenderVHtml>
                            <div
                              :key="
                                'supplementary-details' +
                                epm_evaluation_supplementary.id
                              "
                              class="bibliography-details"
                            >
                              {{ epm_evaluation_supplementary.details }}
                            </div>
                            <BoundedRichText
                              class="bounded-biblio-content"
                              :key="
                                'bounded-biblio-supplementary' +
                                epm_evaluation_supplementary.id
                              "
                              :text="
                                epm_evaluation_supplementary.bibliographic_resource__description
                              "
                              :drop_text="epm_evaluation_supplementary.details"
                              :large="18"
                              :content_width="400"
                            ></BoundedRichText>
                          </template>
                        </template>
                        <template v-else>{{
                          $t("reusable.common.notApplicable")
                        }}</template>
                      </b-td>
                      <b-td
                        :class="[
                          epm_evaluation.study_environments_students.length > 0
                            ? 'text-left'
                            : 'text-center',
                        ]"
                      >
                        <!-- AMBIENTES DE APRENDIZAJE -->
                        <template
                          v-if="
                            epm_evaluation.study_environments_students.length >
                            0
                          "
                        >
                          <div
                            v-for="environment in epm_evaluation.study_environments_students"
                            :key="environment.id"
                            variant="info"
                            class="mr-1"
                          >
                            - {{ environment.name }}:
                            {{ environment.suggested_students }}
                          </div>
                          <!-- {{
                              epm_evaluation.study_environments_students
                                .map(
                                  (x) => `${x.name}: ${x.suggested_students}`
                                )
                                .join(", ")
                            }} -->
                        </template>
                        <template v-else>{{
                          $t("reusable.common.notApplicable")
                        }}</template>
                      </b-td>
                      <b-td>
                        <!-- Nº ESTUDIANTES -->
                        {{
                          epm_evaluation.suggested_students
                            ? epm_evaluation.suggested_students
                            : "-"
                        }}
                      </b-td>
                    </b-tr>
                  </template>
                  <template v-else>
                    <b-tr
                      v-if="
                        StudySuEpmEvaluationCount(learning_experience.id) > 0 &&
                        study_unit.epm_evaluations.length == 0 &&
                        index2 == 0
                      "
                      :key="
                        'learning_experience' +
                        index +
                        'study_unit' +
                        index2 +
                        'epm-evaluation'
                      "
                    >
                      <b-td
                        v-if="index2 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length +
                          1
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <!-- N° y NOMBRE EA -->
                        {{
                          $t("matterProgram.learningExperiencesView.eaPrefix") +
                          " " +
                          learning_experience.order +
                          " - " +
                          learning_experience.name
                        }}
                      </b-td>
                      <b-td
                        v-if="index2 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length +
                          1
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <!-- Resultado(s) de Aprendizaje -->
                        <div
                          v-for="(
                            item, index4
                          ) in learning_experience.study_units"
                          :key="
                            'learning_experience' +
                            index +
                            'study_unit' +
                            index2 +
                            'epm-evaluation' +
                            '-' +
                            index4
                          "
                        >
                          {{
                            $t(
                              "matterProgram.learningExperiencesView.raPrefix"
                            ) +
                            item.order +
                            ". " +
                            item.full_sentence
                          }}
                        </div>
                      </b-td>
                      <b-td
                        v-if="index2 == 0"
                        :rowspan="
                          StudySuEpmEvaluationCount(learning_experience.id) +
                          learning_experience.epm_evaluations.length +
                          1
                        "
                        style="vertical-align: middle; text-align: justify"
                      >
                        <div
                          class="text-break"
                          @click="
                            (e) => e.target.classList.toggle('text-break')
                          "
                        >
                          <!-- DESCRIPCIÓN  -->
                          <template v-if="learning_experience.description">
                            <div
                              :id="`popover-learning_experience.description-${index}-${index2}-`"
                            >
                              <RenderVHtml
                                :content="learning_experience.description"
                              ></RenderVHtml>
                            </div>
                            <b-popover
                              :target="`popover-learning_experience.description-${index}-${index2}-`"
                              triggers="hover"
                              placement="right"
                            >
                              <RenderVHtml
                                class="popover-container"
                                :content="learning_experience.description"
                              ></RenderVHtml>
                            </b-popover>
                          </template>
                          <template v-else>
                            <div>{{ $t("reusable.common.notApplicable") }}</div>
                          </template>
                        </div>
                      </b-td>
                    </b-tr>
                  </template>
                </template>
                <b-tr
                  v-for="(
                    epm_evaluation, index3
                  ) in learning_experience.epm_evaluations"
                  :key="
                    'learning_experience' + index + 'epm-evaluation' + index3
                  "
                >
                  <b-td
                    v-if="
                      index3 == 0 &&
                      StudySuEpmEvaluationCount(learning_experience.id) == 0
                    "
                    :rowspan="learning_experience.epm_evaluations.length"
                    style="vertical-align: middle; text-align: justify"
                  >
                    <!-- N° y NOMBRE EA -->
                    {{
                      $t("matterProgram.learningExperiencesView.eaPrefix") +
                      " " +
                      learning_experience.order +
                      " - " +
                      learning_experience.name
                    }}
                  </b-td>
                  <b-td
                    v-if="
                      index3 == 0 &&
                      StudySuEpmEvaluationCount(learning_experience.id) == 0
                    "
                    :rowspan="learning_experience.epm_evaluations.length"
                    style="vertical-align: middle; text-align: justify"
                  >
                    <!-- Resultado(s) de Aprendizaje -->
                    <div
                      v-for="(item, index4) in learning_experience.study_units"
                      :key="
                        'learning_experience' +
                        index +
                        'study_unit' +
                        index3 +
                        'epm-evaluation' +
                        '-' +
                        index4
                      "
                    >
                      {{
                        $t("matterProgram.learningExperiencesView.raPrefix") +
                        item.order +
                        ". " +
                        item.full_sentence
                      }}
                    </div>
                  </b-td>
                  <b-td
                    v-if="
                      index3 == 0 &&
                      StudySuEpmEvaluationCount(learning_experience.id) == 0
                    "
                    :rowspan="learning_experience.epm_evaluations.length"
                    style="vertical-align: middle; text-align: justify"
                  >
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- DESCRIPCIÓN -->
                      <template v-if="learning_experience.description">
                        <div
                          :id="`popover-learning_experience.description-${index}--${index3}`"
                        >
                          <RenderVHtml
                            :content="learning_experience.description"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-learning_experience.description-${index}--${index3}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="learning_experience.description"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <b-td>
                    <!-- N° y NOMBRE ACTIVIDAD DOCENCIA DIRIGIDA -->
                    <span v-if="epm_evaluation.type_name == 'Actividad'">{{
                      epm_evaluation.full_name
                    }}</span>
                    <template v-else>
                      <span>{{ epm_evaluation.full_name }}</span>
                    </template></b-td
                  >
                  <b-td>
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- Descripción breve DIRIGIDO AL DOCENTE -->
                      <template v-if="epm_evaluation.description">
                        <div
                          :id="`popover-epm_evaluation.description-${index}--${index3}`"
                        >
                          <RenderVHtml
                            :content="epm_evaluation.description"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-epm_evaluation.description-${index}--${index3}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="epm_evaluation.description"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <b-td>
                    <div
                      class="text-break"
                      @click="(e) => e.target.classList.toggle('text-break')"
                    >
                      <!-- Descripción breve DIRIGIDO AL ESTUDIANTE -->
                      <template v-if="epm_evaluation.description_for_student">
                        <div
                          :id="`popover-epm_evaluation.description_for_student-${index}--${index3}`"
                        >
                          <RenderVHtml
                            :content="epm_evaluation.description_for_student"
                          ></RenderVHtml>
                        </div>
                        <b-popover
                          :target="`popover-epm_evaluation.description_for_student-${index}--${index3}`"
                          triggers="hover"
                          placement="right"
                        >
                          <RenderVHtml
                            class="popover-container"
                            :content="epm_evaluation.description_for_student"
                          ></RenderVHtml>
                        </b-popover>
                      </template>
                      <template v-else>
                        <div>{{ $t("reusable.common.notApplicable") }}</div>
                      </template>
                    </div>
                  </b-td>
                  <!-- Vinculación con el Medio -->
                  <b-td>
                    <RenderVHtml
                      :class="{
                        'text-center':
                          epm_evaluation.connection_with_the_environment_description ==
                          '-',
                      }"
                      :content="
                        epm_evaluation.connection_with_the_environment_description
                      "
                    ></RenderVHtml>
                  </b-td>
                  <b-td
                    :class="[
                      epm_evaluation.evaluation_criterias_micro.length > 0
                        ? 'text-left'
                        : 'text-center',
                    ]"
                  >
                    <!-- Indicador(es) de logro -->
                    <template
                      v-if="
                        epm_evaluation.evaluation_criterias_micro.length > 0
                      "
                    >
                      <template
                        v-for="indicator in epm_evaluation.evaluation_criterias_micro"
                        class="indicator-content"
                      >
                        <b-badge
                          :key="indicator.id"
                          :id="`ec-badge-${indicator.id}`"
                          class="ec-micro-badge mr-1"
                          variant="info"
                          v-b-tooltip.v-secondary.noninteractive="
                            `${indicator.full_sentence}`
                          "
                        >
                          {{ indicator.study_unit__order }}.{{
                            indicator.order
                          }}
                        </b-badge>
                      </template>
                    </template>
                    <template v-else>
                      <div>{{ $t("reusable.common.notApplicable") }}</div>
                    </template>
                  </b-td>
                  <b-td>
                    <!-- Tiempo horas docencia dirigida -->
                    {{
                      epm_evaluation.suggested_hours
                        ? epm_evaluation.suggested_hours
                        : "-"
                    }}
                  </b-td>
                  <b-td class="text-justify">
                    <!-- Actividad de trabajo autónomo del/la estudiante -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_autonomous_activities
                          .length > 0
                      "
                    >
                      <RenderVHtml
                        v-for="learning_resource in epm_evaluation.epm_evaluation_autonomous_activities"
                        :key="learning_resource.id"
                        class="mr-1"
                        :content="learning_resource.name"
                      ></RenderVHtml>
                    </template>
                  </b-td>
                  <b-td>
                    <!-- Tiempo horas trabajo autónomo -->
                    {{
                      epm_evaluation.autonomous_work_hours
                        ? epm_evaluation.autonomous_work_hours
                        : "-"
                    }}
                  </b-td>
                  <b-td>
                    <!-- Recursos de aprendizaje -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_learning_resources
                          .length > 0
                      "
                    >
                      <div
                        v-for="learning_resource in epm_evaluation.epm_evaluation_learning_resources"
                        :key="learning_resource.id"
                      >
                        <RenderVHtml
                          :content="learning_resource.description"
                        ></RenderVHtml>
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- Tecnología educativa  -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_educational_technology
                          .length > 0
                      "
                    >
                      <div
                        v-for="epm_evaluation_educational_technology in epm_evaluation.epm_evaluation_educational_technology"
                        :key="epm_evaluation_educational_technology.id"
                      >
                        <RenderVHtml
                          :content="epm_evaluation_educational_technology.description"
                        ></RenderVHtml>
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td class="bibliography-table-cell">
                    <!-- BIBLIOGRAFÍA OBLIGATORIA -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_mandatory_bibliography
                          .length > 0
                      "
                    >
                      <template
                        v-for="epm_evaluation_mandatory in epm_evaluation.epm_evaluation_mandatory_bibliography"
                      >
                        <RenderVHtml
                          :key="'mandatory' + epm_evaluation_mandatory.id"
                          class="bibliography-content"
                          :content="
                            epm_evaluation_mandatory.bibliographic_resource__description
                          "
                        ></RenderVHtml>
                        <div
                          :key="
                            'mandatory-details' + epm_evaluation_mandatory.id
                          "
                          class="bibliography-details"
                        >
                          {{ epm_evaluation_mandatory.details }}
                        </div>
                        <BoundedRichText
                          class="bounded-biblio-content"
                          :key="
                            'bounded-biblio-mandatory' +
                            epm_evaluation_mandatory.id
                          "
                          :text="
                            epm_evaluation_mandatory.bibliographic_resource__description
                          "
                          :drop_text="epm_evaluation_mandatory.details"
                          :large="18"
                          :content_width="50"
                        ></BoundedRichText>
                      </template>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- BIBLIOGRAFÍA COMPLEMENTARIA -->
                    <template
                      v-if="
                        epm_evaluation.epm_evaluation_supplementary_bibliography
                          .length > 0
                      "
                    >
                      <template
                        v-for="epm_evaluation_supplementary in epm_evaluation.epm_evaluation_supplementary_bibliography"
                      >
                        <RenderVHtml
                          :key="
                            'supplementary' + epm_evaluation_supplementary.id
                          "
                          class="bibliography-content"
                          :content="
                            epm_evaluation_supplementary.bibliographic_resource__description
                          "
                        ></RenderVHtml>
                        <div
                          :key="
                            'supplementary-details' +
                            epm_evaluation_supplementary.id
                          "
                          class="bibliography-details"
                        >
                          {{ epm_evaluation_supplementary.details }}
                        </div>
                        <BoundedRichText
                          class="bounded-biblio-content"
                          :key="
                            'bounded-biblio-supplementary' +
                            epm_evaluation_supplementary.id
                          "
                          :text="
                            epm_evaluation_supplementary.bibliographic_resource__description
                          "
                          :drop_text="epm_evaluation_supplementary.details"
                          :large="18"
                          :content_width="400"
                        ></BoundedRichText>
                      </template>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td
                    :class="[
                      epm_evaluation.study_environments.length > 0
                        ? 'text-left'
                        : 'text-center',
                    ]"
                  >
                    <!-- AMBIENTES DE APRENDIZAJE -->
                    <template
                      v-if="
                        epm_evaluation.study_environments_students.length > 0
                      "
                    >
                      <div
                        v-for="environment in epm_evaluation.study_environments_students"
                        :key="environment.id"
                        variant="info"
                        class="mr-1"
                      >
                        - {{ environment.name }}:
                        {{ environment.suggested_students }}
                      </div>
                    </template>
                    <template v-else>{{
                      $t("reusable.common.notApplicable")
                    }}</template>
                  </b-td>
                  <b-td>
                    <!-- Nº ESTUDIANTES -->
                    {{
                      epm_evaluation.suggested_students
                        ? epm_evaluation.suggested_students
                        : "-"
                    }}
                  </b-td>
                </b-tr>
              </template>
            </template>
            <template v-else>
              <b-tr :key="'learning_experience' + index">
                <b-td
                  >{{
                    $t("matterProgram.learningExperiencesView.eaPrefix") +
                    " " +
                    learning_experience.order +
                    " - " +
                    learning_experience.name
                  }}
                </b-td>
                <b-td>
                  <div
                    class="text-break"
                    @click="(e) => e.target.classList.toggle('text-break')"
                  >
                    <template v-if="learning_experience.description">
                      <div
                        :id="`popover-learning_experience.description-${index}-`"
                      >
                        <RenderVHtml
                          :content="learning_experience.description"
                        ></RenderVHtml>
                      </div>
                      <b-popover
                        :target="`popover-learning_experience.description-${index}-`"
                        triggers="hover"
                        placement="right"
                      >
                        <RenderVHtml
                          class="popover-container"
                          :content="learning_experience.description"
                        ></RenderVHtml>
                      </b-popover>
                    </template>
                    <template v-else>
                      <div>{{ $t("reusable.common.notApplicable") }}</div>
                    </template>
                  </div>
                </b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
                <b-td></b-td>
              </b-tr>
            </template>
          </template>
          <template
            v-for="(
              transversal_exam, index
            ) in learning_experiences.transversal_exams"
          >
            <b-tr :key="'transversal_exam' + index">
              <b-td class="align-middle" colspan="3">
                {{
                  $t("matterProgram.learningExperiencesView.transversalExam")
                }}
              </b-td>
              <b-td class="align-middle">
                <!-- N° y NOMBRE ACTIVIDAD DOCENCIA DIRIGIDA -->
                {{ transversal_exam.name }}
              </b-td>
              <b-td>
                <div
                  class="text-break"
                  @click="(e) => e.target.classList.toggle('text-break')"
                >
                  <!-- Descripción breve DIRIGIDO AL DOCENTE -->
                  <template v-if="transversal_exam.description">
                    <div :id="`popover-transversal_exam.description-${index}-`">
                      <RenderVHtml
                        :content="transversal_exam.description"
                      ></RenderVHtml>
                    </div>
                    <b-popover
                      :target="`popover-transversal_exam.description-${index}-`"
                      triggers="hover"
                      placement="right"
                    >
                      <RenderVHtml
                        class="popover-container"
                        :content="transversal_exam.description"
                      ></RenderVHtml>
                    </b-popover>
                  </template>
                </div>
              </b-td>
              <b-td>
                <div
                  class="text-break"
                  @click="(e) => e.target.classList.toggle('text-break')"
                >
                  <!-- Descripción breve DIRIGIDO AL ESTUDIANTE -->
                  <template v-if="transversal_exam.description_for_student">
                    <div
                      :id="`popover-transversal_exam.description_for_student-${index}-`"
                    >
                      <RenderVHtml
                        :content="transversal_exam.description_for_student"
                      ></RenderVHtml>
                    </div>
                    <b-popover
                      :target="`popover-transversal_exam.description_for_student-${index}-`"
                      triggers="hover"
                      placement="right"
                    >
                      <RenderVHtml
                        class="popover-container"
                        :content="transversal_exam.description_for_student"
                      ></RenderVHtml>
                    </b-popover>
                  </template>
                </div>
              </b-td>
              <!-- Vinculación con el Medio -->
              <b-td>
                <RenderVHtml
                  :class="{
                    'text-center':
                      transversal_exam.connection_with_the_environment_description ==
                      '-',
                  }"
                  :content="
                    transversal_exam.connection_with_the_environment_description
                  "
                ></RenderVHtml>
              </b-td>
              <b-td
                :class="[
                  transversal_exam.evaluation_criterias_micro.length > 0
                    ? 'text-left'
                    : 'text-center',
                ]"
              >
                <!-- Indicador(es) de logro -->
                <template
                  v-if="transversal_exam.evaluation_criterias_micro.length > 0"
                >
                  <template
                    v-for="indicator in transversal_exam.evaluation_criterias_micro"
                    class="indicator-content"
                  >
                    <b-badge
                      :key="indicator.id"
                      :id="`ec-badge-trans-${indicator.id}`"
                      class="ec-micro-badge mr-1"
                      variant="info"
                      v-b-tooltip.v-secondary.noninteractive="
                        `${indicator.full_sentence}`
                      "
                    >
                      {{ indicator.study_unit__order }}.{{ indicator.order }}
                    </b-badge>
                  </template>
                </template>
                <template v-else>
                  <div>{{ $t("reusable.common.notApplicable") }}</div>
                </template>
              </b-td>
              <b-td class="align-middle">
                <!-- Tiempo horas docencia dirigida(Horas pedagógicas) -->
                {{ transversal_exam.suggested_hours }}
              </b-td>
              <b-td class="text-justify">
                <!-- Actividad de trabajo autónomo del/la estudiante -->
                <template
                  v-if="
                    transversal_exam.transversal_exam_autonomous_activities
                      .length > 0
                  "
                >
                  <RenderVHtml
                    v-for="learning_resource in transversal_exam.transversal_exam_autonomous_activities"
                    :key="learning_resource.id"
                    class="mr-1"
                    :content="learning_resource.name"
                  ></RenderVHtml>
                </template>
              </b-td>
              <b-td class="align-middle">
                <!-- Tiempo horas trabajo autónomo -->
                {{
                  transversal_exam.autonomous_work_hours
                    ? transversal_exam.autonomous_work_hours
                    : "-"
                }}
              </b-td>
              <b-td class="align-middle">
                <!-- Recursos de aprendizaje -->
                <template
                  v-if="
                    transversal_exam.transversal_exam_learning_resources
                      .length > 0
                  "
                >
                  <RenderVHtml
                    v-for="learning_resource in transversal_exam.transversal_exam_learning_resources"
                    :key="learning_resource.id"
                    class="badge badge-info mr-1"
                    :content="learning_resource.description"
                  ></RenderVHtml>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td class="align-middle">
                <!-- Tecnología educativa  -->
                <template
                  v-if="
                    transversal_exam.transversal_exam_educational_technology
                      .length > 0
                  "
                >
                  <RenderVHtml
                    v-for="educational_technology in transversal_exam.transversal_exam_educational_technology"
                    :key="educational_technology.id"
                    class="badge badge-info mr-1"
                    :content="educational_technology.description"
                  ></RenderVHtml>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td class="bibliography-table-cell">
                <!-- BIBLIOGRAFÍA OBLIGATORIA -->
                <template
                  v-if="
                    transversal_exam.transversal_exam_mandatory_bibliography
                      .length > 0
                  "
                >
                  <template
                    v-for="epm_evaluation_mandatory in transversal_exam.transversal_exam_mandatory_bibliography"
                  >
                    <RenderVHtml
                      :key="'trans-mandatory' + epm_evaluation_mandatory.id"
                      class="bibliography-content"
                      :content="
                        epm_evaluation_mandatory.bibliographic_resource__description
                      "
                    ></RenderVHtml>
                    <div
                      :key="
                        'trans-mandatory-details' + epm_evaluation_mandatory.id
                      "
                      class="bibliography-details"
                    >
                      {{ epm_evaluation_mandatory.details }}
                    </div>
                    <BoundedRichText
                      class="bounded-biblio-content"
                      :key="
                        'bounded-biblio-trans-mandatory' +
                        epm_evaluation_mandatory.id
                      "
                      :text="
                        epm_evaluation_mandatory.bibliographic_resource__description
                      "
                      :drop_text="epm_evaluation_mandatory.details"
                      :large="18"
                      :content_width="400"
                    ></BoundedRichText>
                  </template>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td class="bibliography-table-cell">
                <!-- BIBLIOGRAFÍA COMPLEMENTARIA -->
                <template
                  v-if="
                    transversal_exam.transversal_exam_supplementary_bibliography
                      .length > 0
                  "
                >
                  <template
                    v-for="epm_evaluation_supplementary in transversal_exam.transversal_exam_supplementary_bibliography"
                  >
                    <RenderVHtml
                      :key="
                        'trans-supplementary' + epm_evaluation_supplementary.id
                      "
                      class="bibliography-content"
                      :content="
                        epm_evaluation_supplementary.bibliographic_resource__description
                      "
                    ></RenderVHtml>
                    <div
                      :key="
                        'trans-supplementary-details' +
                        epm_evaluation_supplementary.id
                      "
                      class="bibliography-details"
                    >
                      {{ epm_evaluation_supplementary.details }}
                    </div>
                    <BoundedRichText
                      class="bounded-biblio-content"
                      :key="
                        'bounded-biblio-trans-supplementary' +
                        epm_evaluation_supplementary.id
                      "
                      :text="
                        epm_evaluation_supplementary.bibliographic_resource__description
                      "
                      :drop_text="epm_evaluation_supplementary.details"
                      :large="18"
                      :content_width="400"
                    ></BoundedRichText>
                  </template>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td
                :class="[
                  transversal_exam.study_environments_students.length > 0
                    ? 'text-left'
                    : 'text-center',
                ]"
              >
                <!-- AMBIENTES DE APRENDIZAJE -->
                <template
                  v-if="transversal_exam.study_environments_students.length > 0"
                >
                  <div
                    v-for="environment in transversal_exam.study_environments_students"
                    :key="environment.id"
                    variant="info"
                    class="mr-1"
                  >
                    - {{ environment.name }}:
                    {{ environment.suggested_students }}
                  </div>
                </template>
                <template v-else>{{
                  $t("reusable.common.notApplicable")
                }}</template>
              </b-td>
              <b-td class="align-middle">
                <!-- Nº ESTUDIANTES -->
                {{
                  transversal_exam.suggested_students
                    ? transversal_exam.suggested_students
                    : "-"
                }}
              </b-td>
            </b-tr>
          </template>
        </template>
        <template v-else>
          <b-th colspan="15">
            {{
              $t(
                "matterProgram.learningExperiencesView.noLearningExperiencesRecord",
                {
                  entity: $getVisibleNames(
                    "mesh.egressprofilematter",
                    false,
                    "Asignatura"
                  ),
                }
              )
            }}
          </b-th>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>
<script>
// import { URL } from "@/utils/globals";
import * as names from "@/store/names";
import matterLanguageMixin from "@/mixins/matterLanguageMixin";
import { mapGetters } from "vuex";
import { showLoadingAlert, downloadFileFromResponse } from "@/utils/utils";
export default {
  name: "LearningExperiencesView",
  mixins: [matterLanguageMixin],
  components: {
    BoundedRichText: () => import("@/components/reusable/BoundedRichText"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    TableSkeleton: () => import("@/components/reusable/TableSkeleton"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      learning_experiences: null,
      disabled_button_excel: false,
      egress_profile_matter_id: Number(
        this.$route.params.egress_profile_matter_id
      ),
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      matters: names.MATTERS,
    }),
    isStudent() {
      return this.user && this.user.group_names.includes("ESTUDIANTES");
    },
    isProfessor() {
      return this.user && this.user.group_names.includes("PROFESORES");
    },
    matter() {
      if (!this.egressProfilesMatter) return null;
      return this.matters.find((x) => x.id == this.egressProfilesMatter.matter);
    },
    egressProfilesMatter() {
      if (!this.egress_profile_matter_id) return null;
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    breadcrumb() {
      // Recuperar contexto del breadcrumb desde localStorage
      const context = localStorage.getItem("breadcrumb");
      return context ? JSON.parse(context) : {};
    },
    breadcrumbEgressProfileId() {
      return this.breadcrumb.egress_profile_id || null;
    },
    breadcrumbEgressProfileMatterId() {
      return this.breadcrumb.egress_profile_matter_id || null;
    },
    breadcrumb_items() {
      let breadcrumb = [];
      let egressProfileId =
        this.breadcrumbEgressProfileId ||
        this.egressProfilesMatter?.egress_profile;
      let egressProfileMatterId =
        this.breadcrumbEgressProfileMatterId || this.egress_profile_matter_id;

      if (egressProfileId && egressProfileMatterId) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames("mesh.career", true, "Programas"),
            to: "/careers",
          },
          {
            text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
            to: `/matrix2/form/${egressProfileId}`,
            dropdownOptions: [
              "showEgressProfile",
              "showMatrix1",
              "showMatrix2",
              "showMatrix3",
              "showMatrix4",
              "showStudyPlan",
              "showCurricularMesh",
            ],
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/matter/form/${egressProfileMatterId}`,
          },
          {
            text: this.$t("reusable.breadcrumb.learningExperiences"),
            ...(!this.isStudent &&
              !this.isProfessor && {
                dropdownOptions: [
                  "showMatterDescriptionView",
                  "showLearningEvaluationView",
                  "showPiaView",
                  "showPdaView",
                  "showPaView",
                ],
              }),
          },
        ];
      }
      return breadcrumb;
    },
  },
  methods: {
    fetchLearningExperiences() {
      if (this.egress_profile_matter_id) {
        this.$restful
          .Get(
            `/teaching/learning_experience/?egress_profile_matter=${this.egress_profile_matter_id}`
          )
          .then((response) => {
            this.learning_experiences = response;
            this.loading = false;
          });
      }
    },

    StudySuEpmEvaluationCount(learning_experiences_id) {
      if (!this.learning_experiences) return 0;
      let su_epm_evaluation_count = 0;
      const learning_experience =
        this.learning_experiences.learning_experiences.find(
          (x) => x.id == learning_experiences_id
        );
      if (learning_experience) {
        learning_experience.study_units.forEach((study_unit) => {
          su_epm_evaluation_count += study_unit.su_epm_evaluation_count;
        });
        return su_epm_evaluation_count;
      }
    },
    DownloadXLS() {
      this.disabled_button_excel = true;
      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      // window.open(
      //   URL +
      //     `/teaching/learning_exp_excel_version/?egress_profile_matter=${this.egress_profile_matter_id}`,
      //   "_blank"
      // );
      this.$restful
        .Post(
          `/teaching/learning_exp_excel_version/`,
          {
            egress_profile_matter: this.egress_profile_matter_id,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          // URL + `/teaching/learning_exp_excel_version/?egress_profile_matter=${this.egress_profile_matter_id}`,
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    printingOrientationLandscape() {
      var css = "@media print {@page { size: A4 landscape; }}",
        head = document.head || document.getElementsByTagName("head")[0],
        style = document.createElement("style");
      style.type = "text/css";
      style.media = "print";

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      head.appendChild(style);
    },
    printingOrientationPortrait() {
      var css = "@media print {@page { size: A4 portrait !important; }}",
        head = document.head || document.getElementsByTagName("head")[0],
        style = document.createElement("style");
      style.type = "text/css";
      style.media = "print";

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
      head.appendChild(style);
    },
  },
  watch: {
    egressProfilesMatter: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (
          this.user &&
          this.user.student_card &&
          this.user.group_names.includes("ESTUDIANTES") &&
          this.user.student_card.egress_profile != val.egress_profile
        ) {
          this.$router.push({ name: "Page403" });
        }
        if (this.user && this.user.group_names.includes("PROFESORES")) {
          this.$restful
            .Get(`/mesh/fully_visible_professor_egress_profiles/`)
            .then((response) => {
              if (!response.includes(val.egress_profile)) {
                this.$router.push({ name: "Page403" });
              }
            });
        }
      },
    },
  },
  mounted() {
    if (this.egress_profile_matter_id)
      this.$store
        .dispatch(
          names.FETCH_EGRESS_PROFILE_MATTER,
          this.egress_profile_matter_id
        )
        .then((egress_profile_matter) => {
          this.$store
            .dispatch(names.FETCH_MATTER, egress_profile_matter.matter)
            .then((matter) => {
              this.$store.commit(
                names.MUTATE_TITLE_OF_THE_PRINT,
                this.$t(
                  "matterProgram.learningExperiencesView.learningExperiencesPrintTitle",
                  {
                    code: egress_profile_matter.effective_code,
                    name: matter.name,
                  }
                ).toUpperCase()
              );
              this.applyMatterLanguageById(matter.default_language);
            });
        });
    this.fetchLearningExperiences();
    this.printingOrientationLandscape();
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
    this.printingOrientationPortrait();
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
/* RenderVHtml usado como badge (reemplazo de b-badge): igualar el padding original del badge */
.badge.rich-text-content {
  padding: 0.25em 0.4em;
}
.icon-download {
  padding-bottom: 2px;
}
.primary-header {
  background: #808080 !important;
  color: white;
}
.secondary-header {
  background: #d9d9d9 !important;
}
.indicator-content:first-of-type {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}
.bibliography-content {
  /* max-width: 200px; */
  display: none;
  word-break: break-word;
  text-overflow: ellipsis;
}
.txt-custom {
  font-size: 9pt;
}
.bibliography-details {
  display: none;
  border-top: 1px solid #f1f1f1;
}
.text-break >>> div p {
  max-width: 100px; /* Establece el ancho máximo del div o td */
  overflow: hidden; /* Oculta el contenido que se desborde */
  white-space: nowrap; /*Evita que el texto se divida en varias líneas */
  text-overflow: ellipsis; /* Agrega puntos suspensivos al final del texto desbordado */
}
.popover-container {
  max-height: 400px;
  overflow: auto;
}
.popover-container >>> p {
  padding-bottom: 1rem;
}
@media print {
  .badge {
    border: none !important;
  }
  .learning-experiences-container {
    zoom: 52%;
    display: table;
    table-layout: inherit;
  }
  .bibliography-content,
  .bibliography-details {
    display: block;
  }

  .bounded-biblio-content {
    display: none;
  }
  .ec-micro-badge {
    font-size: var(--thirth-font-size);
    text-align: center;
    width: fit-content !important;
    margin-right: 0.3em;
    border: none;
  }
}
</style>